/**
 * Checkboxes obligatoires avant paiement (panier + tiroir).
 * Désactive le bouton checkout tant que la checkbox n'est pas cochée.
 * Bloque la soumission du formulaire si les prérequis ne sont pas validés.
 */
(function () {
  const SELECTOR_CONTAINER = '[data-cart-mandatory-checkboxes]';
  const SELECTOR_CHECKBOX = '.js-cart-mandatory-checkbox';
  const SELECTOR_CHECKOUT_BUTTON = 'button[name="checkout"], #CartDrawer-Checkout, .js-quote-request-btn';
  const SELECTOR_ERROR = '[data-cart-mandatory-error]';
  const CLASS_DISABLED_CHECKOUT = 'wt-cart__cta--disabled-mandatory';

  function getCheckboxes(container) {
    return Array.from(container.querySelectorAll(SELECTOR_CHECKBOX));
  }

  function getCheckoutButtons(container) {
    return Array.from(container.querySelectorAll(SELECTOR_CHECKOUT_BUTTON));
  }

  function allChecked(container) {
    const checkboxes = getCheckboxes(container);
    if (checkboxes.length < 1) return true;
    return checkboxes.every((cb) => cb.checked);
  }

  function setErrorVisibility(container, visible) {
    var errorNode = container.querySelector(SELECTOR_ERROR);
    if (!errorNode) return;
    errorNode.hidden = !visible;
  }

  function updateCheckoutButton(container) {
    const buttons = getCheckoutButtons(container);
    if (buttons.length < 1) return;
    const checked = allChecked(container);
    buttons.forEach(function (button) {
      button.disabled = !checked;
      button.classList.toggle(CLASS_DISABLED_CHECKOUT, !checked);
      button.setAttribute('aria-disabled', !checked ? 'true' : 'false');
    });
  }

  function bindContainer(container) {
    const checkboxes = getCheckboxes(container);
    const buttons = getCheckoutButtons(container);
    if (checkboxes.length < 1 || buttons.length < 1) return;

    const boundUpdate = () => {
      updateCheckoutButton(container);
      if (allChecked(container)) {
        setErrorVisibility(container, false);
      }
    };
    checkboxes.forEach((cb) => {
      cb.removeEventListener('change', boundUpdate);
      cb.addEventListener('change', boundUpdate);
    });

    updateCheckoutButton(container);
    setErrorVisibility(container, false);
  }

  function init() {
    document.querySelectorAll(SELECTOR_CONTAINER).forEach(bindContainer);
    document.querySelectorAll('.wt-cart__checkbox-richtext a').forEach(function (a) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });
  }

  function interceptSubmit(e) {
    const form = e.target;
    if (form.id !== 'cart' && form.id !== 'CartDrawer-Form') return;
    var container = (e.submitter && e.submitter.closest(SELECTOR_CONTAINER)) || form.closest(SELECTOR_CONTAINER) || document.querySelector(SELECTOR_CONTAINER);
    if (!container) return;
    const checkboxes = getCheckboxes(container);
    if (checkboxes.length < 1) return;
    if (allChecked(container)) return;
    const button = e.submitter;
    if (button && (button.name === 'checkout' || button.id === 'CartDrawer-Checkout')) {
      e.preventDefault();
      setErrorVisibility(container, true);
      const firstUnchecked = checkboxes.find((cb) => !cb.checked);
      if (firstUnchecked) {
        firstUnchecked.focus();
      }
    }
  }

  var initTimeout;
  function debouncedInit() {
    clearTimeout(initTimeout);
    initTimeout = setTimeout(init, 150);
  }

  function onReady() {
    init();
    document.addEventListener('submit', interceptSubmit, true);
    document.addEventListener('cart-drawer:refresh', debouncedInit);
    var drawer = document.getElementById('CartDrawer');
    if (drawer && typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(debouncedInit);
      obs.observe(drawer, { childList: true, subtree: true });
    }
    if (document.getElementById('main-cart-footer')) {
      setTimeout(init, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
